import { render, staticRenderFns } from "./avatar-list.vue?vue&type=template&id=0562ff96"
import script from "./avatar-list.vue?vue&type=script&lang=js"
export * from "./avatar-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports